interface Props {
  onClick: () => void
  isOpen?: boolean
}

export function AndrzejFab({ onClick, isOpen }: Props) {
  return (
    <button
      onClick={onClick}
      className={`fixed bottom-4 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-botanical shadow-lg hover:shadow-xl transition-all duration-200 cursor-pointer border-none ${
        isOpen ? 'right-[calc(340px+1rem)] max-sm:hidden' : 'right-4'
      }`}
      title={isOpen ? 'Zwiń Andrzeja' : 'Otwórz Andrzeja'}
    >
      {isOpen ? (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      ) : (
        <img
          src="/andrzej/andrzej-default.svg"
          alt="Andrzej"
          className="h-10 w-10 rounded-full object-cover"
        />
      )}
    </button>
  )
}
